module.exports = __webpack_public_path__ + "static/INTRO-a69f0a1a0e745006f81c8fb5b7ced14b.png";